import { render } from "./MoreWrapView.vue?vue&type=template&id=73f77f7b&scoped=true"
import script from "./MoreWrapView.vue?vue&type=script&lang=js"
export * from "./MoreWrapView.vue?vue&type=script&lang=js"

import "./MoreWrapView.vue?vue&type=style&index=0&id=73f77f7b&scoped=true&lang=css"

import exportComponent from "D:\\Students\\서용석\\vuestudy\\vuegeoje\\vuegeoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f77f7b"]])

export default __exports__